import { useEffect, useState } from 'react';
import { Navbar, Group, Code, ScrollArea, createStyles, rem, Button, Stack, Text, Title, Divider, Collapse, NavLink as NavButton } from '@mantine/core';
import { IconCode, IconEyeEdit, IconHome, IconManualGearbox, IconUser } from '@tabler/icons-react';
import NavbarLinks from '../data/navbar-links';
import LoginForm from './forms/LoginForm';
import { useDisclosure } from '@mantine/hooks';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = createStyles((theme) => ({
  navbar: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
    paddingBottom: 0,
  },
  navbarLink: {
    padding: 10,
    textDecoration: "none",
    outline: "none",
    fontSize: theme.fontSizes.sm,
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    borderBottom: `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
      color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    }
  },
  innerLink: {
    textDecoration: "none",
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    outline: "none",
    fontSize: theme.fontSizes.sm,
    borderBottom: `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    padding: 10,

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
      color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    }
  }
}));

const AppNavbar = ({hidden}) => {
  const { classes } = useStyles();
  const [showLoginForm, { toggle: toggleLoginForm }] = useDisclosure(false);
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
  }, [])

  return (
    <Navbar hidden={hidden} p="xs" className={classes.navbar} hiddenBreakpoint='sm' width={{ sm: 200, lg: 300 }}>
      <Navbar.Section grow className={classes.links} component={ScrollArea}>
        <Stack spacing="none">
          {
            NavbarLinks.map((link, idx) => {
              if(!link.authRequired || (link.authRequired && authState.isAuthenticated && !link.adminRequired) || (link.authRequired && authState.isAuthenticated && link.adminRequired && authState.user.isAdmin))
              return (
              link.type === "parent" ? (
                <NavButton key={idx} className={classes.navbarLink} label={link.label} icon={<link.icon size="1.1rem" />}>
                  <Stack spacing="none">
                    {
                      link.children.map((childLink, idx2) => (
                        <NavLink key={idx2} to={childLink.location} className={classes.innerLink}>
                          <Group>
                            <childLink.icon size="1.1rem" />
                            <Text>{childLink.label}</Text>
                          </Group>
                        </NavLink>
                      ))
                    }
                  </Stack>
                </NavButton>
              ) : (
              <NavLink key={idx} to={link.location} className={classes.navbarLink}>
                <Group spacing="sm">
                  <link.icon size="1.1rem" />
                  <Text>{link.label}</Text>
                </Group>
              </NavLink>
            ))})
          }
        </Stack>
      </Navbar.Section>
      {
        authState.isAuthenticated === false && (
          <Navbar.Section>
            <NavButton
              active
              label="Sign In / Register"
              description="Sign in with your portal account or create a new one"
              icon={<IconUser size="1rem" stroke={1.5} />}
              onClick={toggleLoginForm}
              mb={showLoginForm ? 15 : 0}
            />
            <Collapse in={showLoginForm} transitionDuration={300} transitionTimingFunction="linear">
              <Stack mb={25}>
                <LoginForm />
              </Stack>
            </Collapse>
          </Navbar.Section>
        )
      }
    </Navbar>
  );
}

export default AppNavbar;